import React from 'react';
import { useField } from 'formik';
import SpecialInstructions from './SpecialInstructions';

export default function Explain({
  name,
  label = 'Please describe:',
  layout = '',
  specialInstructions,
  ...props
}) {
  const [field, meta, helpers] = useField(name);
  const { setValue } = helpers;

  return (
    <div>
      <div className="sm:col-span-3 mb-9">
        {specialInstructions ? (
          <SpecialInstructions
            name={name}
            label={label}
            instructions={specialInstructions}
          />
        ) : (
          <label htmlFor={name}>{label}</label>
        )}
        <div className="mt-1 relative col-span-2 rounded shadow-sm">
          <textarea
            id={name}
            name={name}
            rows={layout === 'small' ? 1 : 6}
            value={field.value}
            onChange={(e) => setValue(e.target.value)}
            className={`block w-full shadow-sm focus:ring-neutral-500 focus:border-neutral-500  text-base rounded-md ${
              meta.touched && meta.error
                ? 'border-warning'
                : 'border-neutral-300'
            }`}
            {...props}
          />
        </div>
      </div>
    </div>
  );
}
